function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { inputTheme } from "./chunk-ICL3HPTT.mjs";

// src/components/select.ts
import { selectAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var $bg = cssVar("select-bg");
var _a;
var baseStyleField = defineStyle(_objectSpread(_objectSpread({}, (_a = inputTheme.baseStyle) == null ? void 0 : _a.field), {}, _defineProperty(_defineProperty(_defineProperty({
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: $bg.reference
}, $bg.variable, "colors.white"), "_dark", _defineProperty({}, $bg.variable, "colors.gray.700")), "> option, > optgroup", {
  bg: $bg.reference
})));
var baseStyleIcon = defineStyle({
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
});
var baseStyle = definePartsStyle({
  field: baseStyleField,
  icon: baseStyleIcon
});
var iconSpacing = defineStyle({
  paddingInlineEnd: "8"
});
var _a2, _b, _c, _d, _e, _f, _g, _h;
var sizes = {
  lg: _objectSpread(_objectSpread({}, (_a2 = inputTheme.sizes) == null ? void 0 : _a2.lg), {}, {
    field: _objectSpread(_objectSpread({}, (_b = inputTheme.sizes) == null ? void 0 : _b.lg.field), iconSpacing)
  }),
  md: _objectSpread(_objectSpread({}, (_c = inputTheme.sizes) == null ? void 0 : _c.md), {}, {
    field: _objectSpread(_objectSpread({}, (_d = inputTheme.sizes) == null ? void 0 : _d.md.field), iconSpacing)
  }),
  sm: _objectSpread(_objectSpread({}, (_e = inputTheme.sizes) == null ? void 0 : _e.sm), {}, {
    field: _objectSpread(_objectSpread({}, (_f = inputTheme.sizes) == null ? void 0 : _f.sm.field), iconSpacing)
  }),
  xs: _objectSpread(_objectSpread({}, (_g = inputTheme.sizes) == null ? void 0 : _g.xs), {}, {
    field: _objectSpread(_objectSpread({}, (_h = inputTheme.sizes) == null ? void 0 : _h.xs.field), iconSpacing),
    icon: {
      insetEnd: "1"
    }
  })
};
var selectTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps
});
export { selectTheme };